import React, { useState, useEffect, useCallback } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { 
  Clock, 
  Users, 
  MapPin, 
  BookOpen, 
  Settings, 
  Calendar,
  Save,
  Plus,
  Trash2,
  Play,
  Download,
  Upload,
  User,
  Building,
  AlertCircle,
  CheckCircle,
  Info,
  Menu,
  X, BarChart2, Search, HeatMap,
  FileText,
  Filter,
  ArrowRight,
  ChartBar,  
} from 'lucide-react';

const TimetableScheduler = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [viewMode, setViewMode] = useState('grid');
  const [errors, setErrors] = useState({});
  const [generationStatus, setGenerationStatus] = useState('idle');
  const [auditLogs, setAuditLogs] = useState([]);
  const [timetable, setTimetable] = useState([]);
  const [conflicts, setConflicts] = useState([]);
   // State for analysis
const [analytics, setAnalytics] = useState({});
const [searchQuery, setSearchQuery] = useState('');



const HeatMap = ({
  value,           // Array of values, e.g., [0,1,2,...]
  weekLabels,      // Array of labels for each week, e.g., ['Mon', 'Tue', ...]
  startDate,       // Date object for start
  endDate,         // Date object for end
  panelColors     // Object mapping value to color, e.g., {0: '#EBEDF0', 1: '#C6E48B', ...}
}) => {
  // Generate date range
  const generateDates = (start, end) => {
    const dates = [];
    let current = new Date(start);
    while (current <= end) {
      dates.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  const dates = generateDates(startDate, endDate);

  // Map data values to dates
  // Assuming 'value' array length matches number of dates
  const dataMap = {};
  dates.forEach((date, index) => {
    dataMap[date.toISOString().slice(0,10)] = value[index] || 0;
  });

  // Generate weeks
  const weeks = [];
  for (let i = 0; i < dates.length; i += 7) {
    weeks.push(dates.slice(i, i + 7));
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {/* Week labels */}
      <div style={{ display: 'flex' }}>
        {weekLabels.map((label, idx) => (
          <div key={idx} style={{ width: 20, textAlign: 'center', fontSize: '0.8em' }}>
            {label}
          </div>
        ))}
      </div>
      {/* Heatmap grid */}
      {weeks.map((week, wIdx) => (
        <div key={wIdx} style={{ display: 'flex' }}>
          {week.map((date, dIdx) => {
            const dateStr = date.toISOString().slice(0,10);
            const val = dataMap[dateStr] || 0;
            const color = panelColors[val] || '#EBEDF0';
            return (
              <div
                key={dIdx}
                title={`${date.toDateString()}: ${val}`}
                style={{
                  width: 20,
                  height: 20,
                  margin: 1,
                  backgroundColor: color,
                  borderRadius: 2,
                }}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};



                      

  const [academicPeriod, setAcademicPeriod] = useState({
    semester: 'Fall 2025',
    startDate: '2025-09-01',
    endDate: '2025-12-15',
    workingDays: [],  
    university: '',    
    customUniversity: "",
    faculty: [],
    customFaculties: [], 
  });

  const facultyMap = {
    'Harvard University': ['Engineering', 'Arts and Sciences', 'Business'],
    'Oxford University': ['Humanities', 'Social Sciences', 'Sciences'],
    'MIT': ['Engineering', 'Science', 'Architecture'],
    'University of Nairobi': ['Arts', 'Sciences', 'Business'],
    'ISBAT University': [
      'Business & Commerce',
      'Engineering',
      'Information and Communications Technology',
      'Health Science'
    ],
  };

  const [timeSlots, setTimeSlots] = useState([
    { id: 1, start: '09:00', end: '10:00', type: 'teaching', fixed: false },
    { id: 2, start: '10:00', end: '11:00', type: 'teaching', fixed: false },
    { id: 3, start: '11:00', end: '12:00', type: 'teaching', fixed: false },
    { id: 4, start: '12:00', end: '13:00', type: 'lunch', fixed: true },
  ]);

  const [rooms, setRooms] = useState([
    { id: 1, name: 'LIB-A-101', capacity: 50, type: 'Lecture Hall', building: 'Library Building', equipment: ['Projector', 'Whiteboard'] },
  ]);


   const [lecturers, setLecturers] = useState([
  {
    id: 1,
    name: ' Mr. Nasser',
    faculty: academicPeriod.faculty?.[0] || '', // Initialize with first faculty if available
    maxLoad: 20,
    courses: [''],
    availability: { monday: true, tuesday: false, wednesday: true, thursday: true, friday: true },
  },
]);

  const [studentGroups, setStudentGroups] = useState([
    { id: 1, name: 'BSc CS Year 1', count: 45, faculty: '', courses: ['CS101'] },
  ]);

 

  const [courses, setCourses] = useState([
    {
      id: 1,
      code: 'CS101',
      name: 'Introduction to Programming',
      faculty: academicPeriod.faculty?.[0] || '', 
      duration: 45,
      sessionsPerWeek: 3,
      sessionDuration: 1,
      roomType: 'Computer Lab',
      type: 'mandatory',
    },
  ]);

const courseOptions = courses.map(course => ({
  value: course.code,
  label: `${course.code} - ${course.name}`,
}));

  // Generate course options filtered by faculty
  const getCourseOptions = (faculty) => {
    return courses
      .filter(course => course.faculty === faculty)
      .map(course => ({
        value: course.code,
        label: `${course.code} - ${course.name}`
      }));
  };

  const [constraints, setConstraints] = useState({
    maxConsecutiveHours: 3,
    minBreakBetweenSessions: 15,
    preferMorningSlots: false,
    clusterStudentClasses: true,
    maxLecturerDailyHours: 6,
    roomUtilizationThreshold: 0.8,
  });

  const tabs = [
    { id: 'overview', label: 'Overview', icon: Info },
    { id: 'time-slots', label: 'Time Slots', icon: Clock },
    { id: 'courses', label: 'Courses', icon: BookOpen },
    { id: 'rooms', label: 'Rooms', icon: Building },
    { id: 'lecturers', label: 'Lecturers', icon: User },
    { id: 'students', label: 'Student Groups', icon: Users },   
    { id: 'constraints', label: 'Constraints', icon: Settings },
    { id: 'generate', label: 'Generate', icon: Play },
    { id: 'audit', label: 'Audit Log', icon: FileText },
    { id: 'analysis', name: 'Analysis', icon: ChartBar },
  ];



  // Validation functions
  const validateAcademicPeriod = (period) => {
    const errors = {};
    if (!period.semester?.trim()) errors.semester = 'Semester is required';
    if (!period.startDate) errors.startDate = 'Start date is required';
    if (!period.endDate) errors.endDate = 'End date is required';
    if (period.startDate && period.endDate && new Date(period.startDate) >= new Date(period.endDate))
      errors.dateRange = 'End date must be after start date';
    if (!period.workingDays?.length) errors.workingDays = 'At least one working day is required';
    if (!period.university) errors.university = 'University is required';
    if (period.university === 'custom' && !period.customUniversity?.trim())
      errors.customUniversity = 'Custom university name is required';
    if (!period.faculty?.length && !period.customFaculty?.trim())
      errors.faculty = 'At least one faculty is required';
    return Object.keys(errors).length ? errors : null;
  };

  const validateTimeSlot = (slot) => {
    const errors = {};
    if (!slot.start || !slot.end) errors.time = 'Start and end times are required';
    if (slot.start >= slot.end) errors.time = 'End time must be after start time';
    if (!['teaching', 'lunch', 'break'].includes(slot.type)) errors.type = 'Invalid slot type';
    return Object.keys(errors).length ? errors : null;
  };

  const validateRoom = (room) => {
    const errors = {};
    if (!room.name?.trim()) errors.name = 'Room name is required';
    if (!room.building?.trim()) errors.building = 'Building is required';
    if (!room.capacity || room.capacity < 1) errors.capacity = 'Valid capacity (minimum 1) is required';
    if (!room.type) errors.type = 'Room type is required';
    return Object.keys(errors).length ? errors : null;
  };

 const validateLecturer = (lecturer) => {
  const errors = {};
  if (!lecturer.name?.trim()) errors.name = 'Lecturer name is required';
  if (!lecturer.faculty?.trim()) errors.faculty = 'Faculty is required';
  if (!lecturer.maxLoad || lecturer.maxLoad < 1) errors.maxLoad = 'Valid max load is required';
  if (lecturer.courses.length === 0) errors.courses = 'At least one course is required';
  if (!Object.values(lecturer.availability).some(v => v)) errors.availability = 'At least one day availability is required';
  return Object.keys(errors).length ? errors : null;
};



  /*const validateLecturer = (lecturer) => {
  const errors = {};
  if (!lecturer.name?.trim()) errors.name = 'Lecturer name is required';
  if (!lecturer.department?.trim()) errors.department = 'Department is required';
  if (!lecturer.maxLoad || lecturer.maxLoad < 1) errors.maxLoad = 'Valid max load is required';
  if (!Object.values(lecturer.availability).some(v => v)) errors.availability = 'At least one day availability is required';
  return Object.keys(errors).length ? errors : null;
};*/

  const validateStudentGroup = (group) => {
  const errors = {};
  if (!group.name?.trim()) errors.name = 'Group name is required';
  if (!group.faculty?.trim()) errors.faculty = 'Faculty is required';
  if (!group.count || group.count < 1) errors.count = 'Valid student count is required';
  //if (!group.courses?.length) errors.courses = 'At least one course is required';
  return Object.keys(errors).length ? errors : null;
};

  const validateCourse = (course) => {
    const errors = {};
    if (!course.code?.trim()) errors.code = 'Course code is required';
    if (!course.name?.trim()) errors.name = 'Course name is required';
    if (!course.faculty) errors.faculty = 'Faculty is required';
    if (!course.duration || course.duration < 15) errors.duration = 'Duration must be at least 15 minutes';
    if (!course.sessionsPerWeek || course.sessionsPerWeek < 1) errors.sessionsPerWeek = 'At least one session per week is required';
    if (!course.sessionDuration || course.sessionDuration < 1) errors.sessionDuration = 'Session duration must be at least 1 hour';
    if (!course.roomType) errors.roomType = 'Room type is required';
    return Object.keys(errors).length ? errors : null;
  };

  const validateConstraints = (constraints) => {
    const errors = {};
    if (constraints.maxConsecutiveHours == null || constraints.maxConsecutiveHours < 1)
      errors.maxConsecutiveHours = 'Max consecutive hours must be at least 1';
    if (constraints.minBreakBetweenSessions == null || constraints.minBreakBetweenSessions < 0)
      errors.minBreakBetweenSessions = 'Break between sessions cannot be negative';
    if (constraints.maxLecturerDailyHours == null || constraints.maxLecturerDailyHours < 1)
      errors.maxLecturerDailyHours = 'Max lecturer daily hours must be at least 1';
    if (
      constraints.roomUtilizationThreshold == null ||
      constraints.roomUtilizationThreshold < 0 ||
      constraints.roomUtilizationThreshold > 1
    )
      errors.roomUtilizationThreshold = 'Room utilization threshold must be between 0 and 1';
    return Object.keys(errors).length ? errors : null;
  };

  const [validationErrors, setValidationErrors] = useState({
    timeSlots: {},
    rooms: {},
    lecturers: {},
    studentGroups: {},
    courses: {},
    academicPeriod: {},
    constraints: {}
  });

  // Get available faculties (combine selected and custom)
  const getAvailableFaculties = () => {
    const selected = academicPeriod.faculty || [];
    const custom = academicPeriod.customFaculty
      ? academicPeriod.customFaculty.split(',').map(f => f.trim()).filter(f => f)
      : [];
    return [...new Set([...selected, ...custom])];
  };

  // Generic CRUD operations
  const addItem = (setter, newItem, validator, tab) => {
    const errors = validator ? validator(newItem) : null;
    if (errors) {
      setValidationErrors(prev => ({
        ...prev,
        [tab]: { ...prev[tab], [Date.now()]: errors }
      }));
      return false;
    }
    const newId = Date.now();
    setter(prev => [...prev, { ...newItem, id: newId }]);
    setValidationErrors(prev => ({
      ...prev,
      [tab]: { ...prev[tab], [newId]: null }
    }));
    setAuditLogs(prev => [...prev, { action: 'add', type: tab, id: newId, timestamp: new Date().toISOString() }]);
    return true;
  };

  const updateItem = (setState, id, updates, validator, tabKey) => {
  setState(prev => {
    const updated = prev.map(item => {
      if (item.id === id) {
        const updatedItem = { ...item, ...updates };
        //console.log('Updating:', id, 'From:', item, 'To:', updatedItem); // Debug log
        const errors = validator ? validator(updatedItem) : {};
        setValidationErrors(prevErrors => ({
          ...prevErrors,
          [tabKey]: {
            ...prevErrors[tabKey],
            [id]: errors
          }
        }));
        return updatedItem;
      }
      return item;
    });
    //console.log('New state:', updated); // Debug log
    return updated;
  });
};

  /*const updateItem = (setter, id, updates, validator, tab) => {
    setter(prev => {
      const currentItem = prev.find(item => item.id === id);
      if (!currentItem) return prev;
      const updatedItem = { ...currentItem, ...updates };
      const errors = validator ? validator(updatedItem) : null;
      setValidationErrors(prevErrors => ({
        ...prevErrors,
        [tab]: { ...prevErrors[tab], [id]: errors }
      }));
      if (errors) return prev;
      return prev.map(item => item.id === id ? updatedItem : item);
    });
    setAuditLogs(prev => [...prev, { action: 'update', type: tab, id, timestamp: new Date().toISOString() }]);
  };*/

  const removeItem = useCallback((setter, id, tab) => {
    setter(prev => prev.filter(item => item.id !== id));
    setAuditLogs(prev => [...prev, { action: 'remove', type: tab, id, timestamp: new Date().toISOString() }]);
  }, []);

  // Validate current tab and proceed to next
  const handleNextTab = useCallback(async (currentTabId) => {
    let data, validator, tabKey;
    switch (currentTabId) {
      case 'overview':
        data = academicPeriod;
        validator = validateAcademicPeriod;
        tabKey = 'academicPeriod';
        break;
      case 'time-slots':
        data = timeSlots;
        validator = validateTimeSlot;
        tabKey = 'timeSlots';
        break;
      case 'rooms':
        data = rooms;
        validator = validateRoom;
        tabKey = 'rooms';
        break;
      case 'lecturers':
        data = lecturers;
        validator = validateLecturer;
        tabKey = 'lecturers';
        break;
      case 'students':
        data = studentGroups;
        validator = validateStudentGroup;
        tabKey = 'studentGroups';
        break;
      case 'courses':
        data = courses;
        validator = validateCourse;
        tabKey = 'courses';
        break;
      case 'constraints':
        data = constraints;
        validator = validateConstraints;
        tabKey = 'constraints';
        break;
      case 'generate':
        return true;  
      case 'analysis':
        return true;      
      default:
        return false;
    }

    let errors = {};
    if (Array.isArray(data)) {
      if (!data.length) {
        errors.form = 'At least one item is required';
      } else {
        data.forEach(item => {
          const itemErrors = validator(item);
          if (itemErrors) errors[item.id] = itemErrors;
        });
      }
    } else {
      errors = validator(data) || {};
    }

    if (Object.keys(errors).length > 0) {
    setValidationErrors(prev => ({ ...prev, [tabKey]: errors }));
    setErrors(prev => ({ ...prev, [currentTabId]: 'Please fix all validation errors' }));
    return false;
  }

  // Only save if we're on the last tab
  const currentIndex = tabs.findIndex(tab => tab.id === currentTabId);
  const isLastTab = currentIndex === tabs.length - 1;

  if (isLastTab) {
    try {
      await axios.post(`/api/save/${currentTabId}`, data);
      setAuditLogs(prev => [...prev, { action: 'save', type: currentTabId, timestamp: new Date().toISOString() }]);
      // Handle successful submission
      return true;
    } catch (error) {
      setErrors(prev => ({ ...prev, [currentTabId]: 'Failed to save data' }));
      return false;
    }
  } else {
    // Just move to next tab without saving
    const nextTab = tabs[currentIndex + 1]?.id;
    setActiveTab(nextTab);
    return true;
  }
}, [timeSlots, rooms, lecturers, studentGroups, courses, constraints, academicPeriod, tabs]);


// Generate timetable
const generateTimetable = useCallback(async () => {
  const allData = { timeSlots, rooms, lecturers, studentGroups, courses, constraints, academicPeriod };
  const errors = {};

  if (!timeSlots.length) errors['time-slots'] = 'At least one time slot is required';
  if (!rooms.length) errors['rooms'] = 'At least one room is required';
  if (!lecturers.length) errors['lecturers'] = 'At least one lecturer is required';
  if (!studentGroups.length) errors['students'] = 'At least one student group is required';
  if (!courses.length) errors['courses'] = 'At least one course is required';
  const periodError = validateAcademicPeriod(academicPeriod);
  if (periodError) errors['academic-period'] = periodError;
  const constraintsError = validateConstraints(constraints);
  if (constraintsError) errors['constraints'] = constraintsError;

  if (Object.keys(errors).length > 0) {
    setErrors(errors);
    setGenerationStatus('error');
    setConflicts([]);
    setTimetable([]);
    setAnalytics({});
    return;
  }

  setGenerationStatus('running');
  try {
    const response = await axios.post('/api/generate-timetable', allData);
    const { status, timetable: generatedTimetable, conflicts: generatedConflicts, message } = response.data;

    setTimetable(generatedTimetable || []);
    setConflicts(generatedConflicts || []);
    setGenerationStatus(status === 'success' && generatedConflicts.length === 0 ? 'success' : 'error');
    setAuditLogs(prev => [...prev, { action: 'generate', timestamp: new Date().toISOString(), result: response.data }]);
    setErrors({});

    if (generatedConflicts.length > 0) {
      setErrors(prev => ({ ...prev, generate: 'Timetable generation encountered conflicts. Please resolve them below.' }));
    } else if (status === 'success') {
      // Fetch analytics and redirect to Analysis Tab
      try {
        const analyticsResponse = await axios.post('/api/timetable-analytics', {
          timetable: generatedTimetable,
          rooms,
          lecturers,
          student_groups: studentGroups,
          time_slots: timeSlots,
          working_days: academicPeriod.workingDays
        });
        setAnalytics(analyticsResponse.data);
        setActiveTab('analysis');
      } catch (error) {
        console.error('Analytics fetch failed:', error);
      }
    }
  } catch (error) {
    setGenerationStatus('error');
    setErrors(prev => ({ ...prev, generate: 'Failed to generate timetable' }));
    setConflicts([]);
    setTimetable([]);
    setAnalytics({});
  }
}, [timeSlots, rooms, lecturers, studentGroups, courses, constraints, academicPeriod]);

// Map conflicts to tabs
const getConflictTab = (conflict) => {
  if (conflict.message.includes('No lecturer available')) return 'lecturers';
  if (conflict.message.includes('No room of type')) return 'rooms';
  if (conflict.message.includes('No student group assigned')) return 'students';
  if (conflict.message.includes('Could not schedule session')) return 'constraints';
  return 'overview';
};


  // Save tab data to backend
  const saveTabData = useCallback(async (tabId) => {
    let data;
    let validator;
    switch (tabId) {
      case 'time-slots':
        data = timeSlots;
        validator = validateTimeSlot;
        break;
      case 'rooms':
        data = rooms;
        validator = validateRoom;
        break;
      case 'lecturers':
        data = lecturers;
        validator = validateLecturer;
        break;      
      case 'courses':
        data = courses;
        validator = validateCourse;
        break;
      case 'students':
        data = studentGroups;
        validator = validateStudentGroup;
        break;
      case 'constraints':
        data = constraints;
        validator = validateConstraints;
        break;
      case 'academic-period':
        data = academicPeriod;
        validator = validateAcademicPeriod;
        break;
      default:
        return false;
    }

    const errors = Array.isArray(data)
      ? data.reduce((acc, item) => {
          const error = validator ? validator(item) : null;
          if (error) acc[item.id] = error;
          return acc;
        }, {})
      : validator(data);

    if (Object.keys(errors).length > 0 || errors) {
      setErrors(prev => ({ ...prev, ...(typeof errors === 'string' ? { [tabId]: errors } : errors), [tabId]: errors ? 'Validation errors found in data' : undefined }));
      return false;
    }

    try {
      await axios.post(`/api/save/${tabId}`, data);
      setAuditLogs(prev => [...prev, { action: 'save', type: tabId, timestamp: new Date().toISOString() }]);
      setErrors(prev => ({ ...prev, [tabId]: undefined }));
      return true;
    } catch (error) {
      setErrors(prev => ({ ...prev, [tabId]: 'Failed to save data to backend' }));
      return false;
    }
  }, [timeSlots, rooms, lecturers, studentGroups, courses, constraints, academicPeriod]);

  // Save all data
  const saveAllData = useCallback(async () => {
    const allData = { timeSlots, rooms, lecturers, studentGroups, courses, constraints, academicPeriod };
    const errors = {};

    if (!timeSlots.length) errors['time-slots'] = 'At least one time slot is required';
    if (!rooms.length) errors['rooms'] = 'At least one room is required';
    if (!lecturers.length) errors['lecturers'] = 'At least one lecturer is required';
    if (!studentGroups.length) errors['students'] = 'At least one student group is required';
    if (!courses.length) errors['courses'] = 'At least one course is required';
    const periodError = validateAcademicPeriod(academicPeriod);
    if (periodError) errors['academic-period'] = periodError;
    const constraintsError = validateConstraints(constraints);
    if (constraintsError) errors['constraints'] = constraintsError;

    // Validate all items
    timeSlots.forEach(slot => {
      const error = validateTimeSlot(slot);
      if (error) errors[slot.id] = error;
    });
    rooms.forEach(room => {
      const error = validateRoom(room);
      if (error) errors[room.id] = error;
    });
    lecturers.forEach(lecturer => {
      const error = validateLecturer(lecturer);
      if (error) errors[lecturer.id] = error;
    });
    studentGroups.forEach(group => {
      const error = validateStudentGroup(group);
      if (error) errors[group.id] = error;
    });
    courses.forEach(course => {
      const error = validateCourse(course);
      if (error) errors[course.id] = error;
    });

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return false;
    }

    try {
      await axios.post('/api/save/all', allData);
      setAuditLogs(prev => [...prev, { action: 'save-all', timestamp: new Date().toISOString() }]);
      setErrors({});
      return true;
    } catch (error) {
      setErrors(prev => ({ ...prev, global: 'Failed to save all data' }));
      return false;
    }
  }, [timeSlots, rooms, lecturers, studentGroups, courses, constraints, academicPeriod]);

 
 

  // Components
  const StatCard = ({ title, value, icon: Icon, color }) => (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 transition-all hover:shadow-md">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
        </div>
        <div className={`p-3 rounded-lg ${color}`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
      </div>
    </div>
  );

  const renderOverview = () => (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-900">Academic Period</h3>
          <button
            onClick={() => handleNextTab('overview')}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <ArrowRight className="w-4 h-4" />
            <span>Next</span>
          </button>
        </div>
        {validationErrors.academicPeriod?.form && (
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2 mb-4">
            <AlertCircle className="w-5 h-5 text-red-500" />
            <span className="text-sm text-red-600">{validationErrors.academicPeriod.form}</span>
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Semester</label>
            <input
              type="text"
              value={academicPeriod.semester}
              onChange={(e) => setAcademicPeriod(prev => ({ ...prev, semester: e.target.value }))}
              className={`w-full border ${validationErrors.academicPeriod?.semester ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
            />
            {validationErrors.academicPeriod?.semester && (
              <p className="mt-1 text-sm text-red-600">{validationErrors.academicPeriod.semester}</p>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Start Date</label>
            <input
              type="date"
              value={academicPeriod.startDate}
              onChange={(e) => setAcademicPeriod(prev => ({ ...prev, startDate: e.target.value }))}
              className={`w-full border ${validationErrors.academicPeriod?.startDate ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
            />
            {validationErrors.academicPeriod?.startDate && (
              <p className="mt-1 text-sm text-red-600">{validationErrors.academicPeriod.startDate}</p>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">End Date</label>
            <input
              type="date"
              value={academicPeriod.endDate}
              onChange={(e) => setAcademicPeriod(prev => ({ ...prev, endDate: e.target.value }))}
              className={`w-full border ${validationErrors.academicPeriod?.endDate ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
            />
            {validationErrors.academicPeriod?.endDate && (
              <p className="mt-1 text-sm text-red-600">{validationErrors.academicPeriod.endDate}</p>
            )}
          </div>
        </div>
        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Select Working Days</label>
          <div className="flex flex-wrap gap-2">
            {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => (
              <button
                key={day}
                type="button"
                onClick={() =>
                  setAcademicPeriod((prev) => {
                    const selected = prev.workingDays || [];
                    return {
                      ...prev,
                      workingDays: selected.includes(day)
                        ? selected.filter((d) => d !== day)
                        : [...selected, day],
                    };
                  })
                }
                className={`px-4 py-2 rounded-full border ${
                  academicPeriod.workingDays?.includes(day)
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100 text-gray-800"
                } hover:bg-blue-500 hover:text-white transition`}
              >
                {day}
              </button>
            ))}
          </div>
          {validationErrors.academicPeriod?.workingDays && (
            <p className="mt-1 text-sm text-red-600">{validationErrors.academicPeriod.workingDays}</p>
          )}
        </div>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">University</label>
            <select
              value={academicPeriod.university}
              onChange={(e) => {
                const value = e.target.value;
                setAcademicPeriod((prev) => ({
                  ...prev,
                  university: value,
                  customUniversity: value === "custom" ? "" : prev.customUniversity,
                  faculty: [],
                }));
              }}
              className={`w-full border ${validationErrors.academicPeriod?.university ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2`}
            >
              <option value="">Select University</option>
              <option value="ISBAT University">ISBAT University</option>
              <option value="Harvard University">Harvard University</option>
              <option value="Oxford University">Oxford University</option>
              <option value="MIT">MIT</option>
              <option value="University of Nairobi">University of Nairobi</option>
              <option value="custom">Other (Custom)</option>
            </select>
            {validationErrors.academicPeriod?.university && (
              <p className="mt-1 text-sm text-red-600">{validationErrors.academicPeriod.university}</p>
            )}
            
            {academicPeriod.university === "custom" && (
              <>
                <input
                  type="text"
                  placeholder="Enter University Name"
                  value={academicPeriod.customUniversity}
                  onChange={(e) =>
                    setAcademicPeriod((prev) => ({ ...prev, customUniversity: e.target.value }))
                  }
                  className={`mt-2 w-full border ${validationErrors.academicPeriod?.customUniversity ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2`}
                />
                {validationErrors.academicPeriod?.customUniversity && (
                  <p className="mt-1 text-sm text-red-600">{validationErrors.academicPeriod.customUniversity}</p>
                )}
              </>
            )}
          </div>
          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Select Faculties</label>
            <div className="flex flex-wrap gap-2">
              {(facultyMap[academicPeriod.university] || []).map((faculty) => (
                <button
                  key={faculty}
                  type="button"
                  onClick={() => {
                    const selected = academicPeriod.faculty || [];
                    setAcademicPeriod((prev) => ({
                      ...prev,
                      faculty: selected.includes(faculty)
                        ? selected.filter((f) => f !== faculty)
                        : [...selected, faculty],
                    }));
                  }}
                  className={`px-3 py-1 border rounded-full ${
                    academicPeriod.faculty?.includes(faculty)
                      ? "bg-blue-600 text-white"
                      : "bg-gray-100 text-gray-800"
                  }`}
                >
                  {faculty}
                </button>
              ))}
            </div>
            {/* Custom Faculties - Add/Remove Input Fields */}
              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Custom Faculties</label>
                {academicPeriod.customFaculties.map((faculty, index) => (
                  <div key={index} className="flex items-center gap-2 mb-2">
                    <input
                      type="text"
                      value={faculty}
                      onChange={(e) => {
                        const updated = [...academicPeriod.customFaculties];
                        updated[index] = e.target.value;
                        setAcademicPeriod((prev) => ({ ...prev, customFaculties: updated }));
                      }}
                      placeholder={`Faculty ${index + 1}`}
                      className="flex-1 border border-gray-300 rounded-lg px-3 py-2"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const updated = academicPeriod.customFaculties.filter((_, i) => i !== index);
                        setAcademicPeriod((prev) => ({ ...prev, customFaculties: updated }));
                      }}
                      className="text-red-500 hover:text-red-700"
                    >
                      ✖
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={() =>
                    setAcademicPeriod((prev) => ({
                      ...prev,
                      customFaculties: [...prev.customFaculties, ""],
                    }))
                  }
                  className="mt-2 text-sm text-blue-600 hover:text-blue-800"
                >
                  + Add Custom Faculty
                </button>
              </div>

            {validationErrors.academicPeriod?.faculty && (
              <p className="mt-1 text-sm text-red-600">{validationErrors.academicPeriod.faculty}</p>
            )}
          </div>
        </div>
        {(academicPeriod.faculty?.length > 0 || academicPeriod.customFaculty) && (
          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Selected Faculties</label>
            <div className="flex flex-wrap gap-2">
              {academicPeriod.faculty.map((f, i) => (
                <span key={i} className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">
                  {f}
                </span>
              ))}
              {academicPeriod.customFaculties.map((f, i) => (
                f && (
                  <span key={`custom-${i}`} className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full text-sm">
                    {f}
                  </span>
                )
              ))}
            </div>
          </div>

        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard title="Total Courses" value={courses.length} icon={BookOpen} color="bg-blue-500" />
        <StatCard title="Lecturers" value={lecturers.length} icon={User} color="bg-green-500" />
        <StatCard title="Rooms" value={rooms.length} icon={Building} color="bg-purple-500" />
        <StatCard title="Student Groups" value={studentGroups.length} icon={Users} color="bg-orange-500" />
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">System Status</h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
            <div className="flex items-center space-x-3">
              <CheckCircle className="w-5 h-5 text-green-500" />
              <span className="text-sm font-medium text-green-800">Time Slots Configured</span>
            </div>
            <span className="text-sm text-green-600">{timeSlots.length} slots</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-blue-50 rounded-lg">
            <div className="flex items-center space-x-3">
              <CheckCircle className="w-5 h-5 text-blue-500" />
              <span className="text-sm font-medium text-blue-800">Resources Added</span>
            </div>
            <span className="text-sm text-blue-600">{rooms.length + lecturers.length} items</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-purple-50 rounded-lg">
            <div className="flex items-center space-x-3">
              <CheckCircle className="w-5 h-5 text-purple-500" />
              <span className="text-sm font-medium text-purple-800">Courses & Groups</span>
            </div>
            <span className="text-sm text-purple-600">{courses.length + studentGroups.length} items</span>
          </div>
        </div>
      </div>
    </div>
  );

  const renderTimeSlots = () => (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold text-gray-900">Time Slot Configuration</h2>
        <div className="flex space-x-4">
          <button
            onClick={() => setViewMode('grid')}
            className={`px-3 py-1 rounded-lg ${viewMode === 'grid' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`}
          >
            Grid
          </button>
          <button
            onClick={() => setViewMode('list')}
            className={`px-3 py-1 rounded-lg ${viewMode === 'list' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`}
          >
            List
          </button>
          <button
            onClick={() => addItem(setTimeSlots, { start: '08:00', end: '09:00', type: 'teaching', fixed: false }, validateTimeSlot, 'timeSlots')}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
            <span>Add Slot</span>
          </button>
          <button
            onClick={() => handleNextTab('time-slots')}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <ArrowRight className="w-4 h-4" />
            <span>Next</span>
          </button>
        </div>
      </div>
      {errors['time-slots'] && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2">
          <AlertCircle className="w-5 h-5 text-red-500" />
          <span className="text-sm text-red-600">{errors['time-slots']}</span>
        </div>
      )}
      <div className="max-h-[500px] overflow-y-auto">
        {viewMode === 'grid' ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {timeSlots.map(slot => (
              <div key={slot.id} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Start Time</label>
                    <input
                      type="time"
                      value={slot.start}
                      onChange={(e) => updateItem(setTimeSlots, slot.id, { start: e.target.value }, validateTimeSlot, 'timeSlots')}
                      className={`w-full border ${validationErrors.timeSlots[slot.id]?.time ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    />
                    {validationErrors.timeSlots[slot.id]?.time && (
                      <p className="mt-1 text-sm text-red-600">{validationErrors.timeSlots[slot.id].time}</p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">End Time</label>
                    <input
                      type="time"
                      value={slot.end}
                      onChange={(e) => updateItem(setTimeSlots, slot.id, { end: e.target.value }, validateTimeSlot, 'timeSlots')}
                      className={`w-full border ${validationErrors.timeSlots[slot.id]?.time ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Type</label>
                    <select
                      value={slot.type}
                      onChange={(e) => updateItem(setTimeSlots, slot.id, { type: e.target.value }, validateTimeSlot, 'timeSlots')}
                      className={`w-full border ${validationErrors.timeSlots[slot.id]?.type ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    >
                      <option value="teaching">Teaching</option>
                      <option value="lunch">Lunch Break</option>
                      <option value="break">Break</option>
                    </select>
                    {validationErrors.timeSlots[slot.id]?.type && (
                      <p className="mt-1 text-sm text-red-600">{validationErrors.timeSlots[slot.id].type}</p>
                    )}
                  </div>
                  <div className="flex justify-between items-center">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        slot.fixed ? 'bg-red-100 text-red-800' : slot.type === 'lunch' ? 'bg-orange-100 text-orange-800' : 'bg-green-100 text-green-800'
                      }`}
                    >
                      {slot.fixed ? 'Fixed' : slot.type === 'lunch' ? 'Break' : 'Available'}
                    </span>
                    {!slot.fixed && (
                      <button
                        onClick={() => removeItem(setTimeSlots, slot.id, 'timeSlots')}
                        className="text-red-600 hover:text-red-800 transition-colors"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200">
            <div className="grid grid-cols-5 gap-4 p-4 bg-gray-50 border-b">
              <div className="font-semibold text-gray-700">Start Time</div>
              <div className="font-semibold text-gray-700">End Time</div>
              <div className="font-semibold text-gray-700">Type</div>
              <div className="font-semibold text-gray-700">Status</div>
              <div className="font-semibold text-gray-700">Actions</div>
            </div>
            {timeSlots.map(slot => (
              <div key={slot.id} className="grid grid-cols-5 gap-4 p-4 border-b border-gray-100 items-center">
                <div>
                  <input
                    type="time"
                    value={slot.start}
                    onChange={(e) => updateItem(setTimeSlots, slot.id, { start: e.target.value }, validateTimeSlot, 'timeSlots')}
                    className={`w-full border ${validationErrors.timeSlots[slot.id]?.time ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {validationErrors.timeSlots[slot.id]?.time && (
                    <p className="mt-1 text-sm text-red-600">{validationErrors.timeSlots[slot.id].time}</p>
                  )}
                </div>
                <div>
                  <input
                    type="time"
                    value={slot.end}
                    onChange={(e) => updateItem(setTimeSlots, slot.id, { end: e.target.value }, validateTimeSlot, 'timeSlots')}
                    className={`w-full border ${validationErrors.timeSlots[slot.id]?.time ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                </div>
                <div>
                  <select
                    value={slot.type}
                    onChange={(e) => updateItem(setTimeSlots, slot.id, { type: e.target.value }, validateTimeSlot, 'timeSlots')}
                    className={`w-full border ${validationErrors.timeSlots[slot.id]?.type ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  >
                    <option value="teaching">Teaching</option>
                    <option value="lunch">Lunch Break</option>
                    <option value="break">Break</option>
                  </select>
                  {validationErrors.timeSlots[slot.id]?.type && (
                    <p className="mt-1 text-sm text-red-600">{validationErrors.timeSlots[slot.id].type}</p>
                  )}
                </div>
                <div>
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                      slot.fixed ? 'bg-red-100 text-red-800' : slot.type === 'lunch' ? 'bg-orange-100 text-orange-800' : 'bg-green-100 text-green-800'
                    }`}
                  >
                    {slot.fixed ? 'Fixed' : slot.type === 'lunch' ? 'Break' : 'Available'}
                  </span>
                </div>
                <div className="flex space-x-2">
                  {!slot.fixed && (
                    <button
                      onClick={() => removeItem(setTimeSlots, slot.id, 'timeSlots')}
                      className="text-red-600 hover:text-red-800 transition-colors"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  const renderRooms = () => (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold text-gray-900">Room Management</h2>
        <div className="flex space-x-4">
          <button
            onClick={() => setViewMode('grid')}
            className={`px-3 py-1 rounded-lg ${viewMode === 'grid' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`}
          >
            Grid
          </button>
          <button
            onClick={() => setViewMode('list')}
            className={`px-3 py-1 rounded-lg ${viewMode === 'list' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`}
          >
            List
          </button>
          <button
            onClick={() => addItem(setRooms, { 
              name: 'Room ' + (rooms.length + 1), 
              capacity: 30, 
              type: 'General Classroom', 
              building: 'Main Building',
              equipment: [] 
            }, validateRoom, 'rooms')}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
            <span>Add Room</span>
          </button>
          <button
            onClick={() => handleNextTab('rooms')}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <ArrowRight className="w-4 h-4" />
            <span>Next</span>
          </button>
        </div>
      </div>
      {errors['rooms'] && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2">
          <AlertCircle className="w-5 h-5 text-red-500" />
          <span className="text-sm text-red-600">{errors['rooms']}</span>
        </div>
      )}
      <div className="max-h-[500px] overflow-y-auto">
        {viewMode === 'grid' ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {rooms.map(room => (
              <div key={room.id} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <div className="flex justify-between items-start mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-purple-100 rounded-lg">
                      <Building className="w-5 h-5 text-purple-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{room.name || 'New Room'}</h3>
                      <p className="text-sm text-gray-600">{room.building}</p>
                    </div>
                  </div>
                  <button
                    onClick={() => removeItem(setRooms, room.id, 'rooms')}
                    className="text-red-600 hover:text-red-800 transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Room Name</label>
                    <input
                      type="text"
                      placeholder="e.g., LIB-A-101"
                      value={room.name}
                      onChange={(e) => updateItem(setRooms, room.id, { name: e.target.value }, validateRoom, 'rooms')}
                      className={`w-full border ${validationErrors.rooms[room.id]?.name ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    />
                    {validationErrors.rooms[room.id]?.name && (
                      <p className="mt-1 text-sm text-red-600">{validationErrors.rooms[room.id].name}</p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Building</label>
                    <input
                      type="text"
                      placeholder="e.g., Library Building"
                      value={room.building}
                      onChange={(e) => updateItem(setRooms, room.id, { building: e.target.value }, validateRoom, 'rooms')}
                      className={`w-full border ${validationErrors.rooms[room.id]?.building ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    />
                    {validationErrors.rooms[room.id]?.building && (
                      <p className="mt-1 text-sm text-red-600">{validationErrors.rooms[room.id].building}</p>
                    )}
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Capacity</label>
                      <input
                        type="number"
                        placeholder="Capacity"
                        value={room.capacity}
                        onChange={(e) => updateItem(setRooms, room.id, { capacity: parseInt(e.target.value) || 0 }, validateRoom, 'rooms')}
                        className={`w-full border ${validationErrors.rooms[room.id]?.capacity ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                      />
                      {validationErrors.rooms[room.id]?.capacity && (
                        <p className="mt-1 text-sm text-red-600">{validationErrors.rooms[room.id].capacity}</p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Room Type</label>
                      <select
                        value={room.type}
                        onChange={(e) => updateItem(setRooms, room.id, { type: e.target.value }, validateRoom, 'rooms')}
                        className={`w-full border ${validationErrors.rooms[room.id]?.type ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                      >
                        <option value="General Classroom">General Classroom</option>
                        <option value="Lecture Hall">Lecture Hall</option>
                        <option value="Computer Lab">Computer Lab</option>
                        <option value="Chemistry Lab">Chemistry Lab</option>
                        <option value="Physics Lab">Physics Lab</option>
                        <option value="Biology Lab">Biology Lab</option>
                      </select>
                      {validationErrors.rooms[room.id]?.type && (
                        <p className="mt-1 text-sm text-red-600">{validationErrors.rooms[room.id].type}</p>
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Equipment (comma-separated)</label>
                    <input
                      type="text"
                      placeholder="e.g., Projector, Whiteboard"
                      value={room.equipment?.join(', ') || ''}
                      onChange={(e) => updateItem(setRooms, room.id, { equipment: e.target.value.split(',').map(s => s.trim()) }, validateRoom, 'rooms')}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200">
            <div className="grid grid-cols-6 gap-4 p-4 bg-gray-50 border-b">
              <div className="font-semibold text-gray-700">Room Name</div>
              <div className="font-semibold text-gray-700">Building</div>
              <div className="font-semibold text-gray-700">Capacity</div>
              <div className="font-semibold text-gray-700">Type</div>
              <div className="font-semibold text-gray-700">Equipment</div>
              <div className="font-semibold text-gray-700">Actions</div>
            </div>
            {rooms.map(room => (
              <div key={room.id} className="grid grid-cols-6 gap-4 p-4 border-b border-gray-100 items-center">
                <div>
                  <input
                    type="text"
                    value={room.name}
                    onChange={(e) => updateItem(setRooms, room.id, { name: e.target.value }, validateRoom, 'rooms')}
                    className={`w-full border ${validationErrors.rooms[room.id]?.name ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {validationErrors.rooms[room.id]?.name && (
                    <p className="mt-1 text-sm text-red-600">{validationErrors.rooms[room.id].name}</p>
                  )}
                </div>
                <div>
                  <input
                    type="text"
                    value={room.building}
                    onChange={(e) => updateItem(setRooms, room.id, { building: e.target.value }, validateRoom, 'rooms')}
                    className={`w-full border ${validationErrors.rooms[room.id]?.building ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {validationErrors.rooms[room.id]?.building && (
                    <p className="mt-1 text-sm text-red-600">{validationErrors.rooms[room.id].building}</p>
                  )}
                </div>
                <div>
                  <input
                    type="number"
                    value={room.capacity}
                    onChange={(e) => updateItem(setRooms, room.id, { capacity: parseInt(e.target.value) || 0 }, validateRoom, 'rooms')}
                    className={`w-full border ${validationErrors.rooms[room.id]?.capacity ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {validationErrors.rooms[room.id]?.capacity && (
                    <p className="mt-1 text-sm text-red-600">{validationErrors.rooms[room.id].capacity}</p>
                  )}
                </div>
                <div>
                  <select
                    value={room.type}
                    onChange={(e) => updateItem(setRooms, room.id, { type: e.target.value }, validateRoom, 'rooms')}
                    className={`w-full border ${validationErrors.rooms[room.id]?.type ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  >
                    <option value="General Classroom">General Classroom</option>
                    <option value="Lecture Hall">Lecture Hall</option>
                    <option value="Computer Lab">Computer Lab</option>
                    <option value="Chemistry Lab">Chemistry Lab</option>
                  </select>
                  {validationErrors.rooms[room.id]?.type && (
                    <p className="mt-1 text-sm text-red-600">{validationErrors.rooms[room.id].type}</p>
                  )}
                </div>
                <div>
                  <input
                    lança type="text"
                    value={room.equipment?.join(', ') || ''}
                    onChange={(e) => updateItem(setRooms, room.id, { equipment: e.target.value.split(',').map(s => s.trim()) }, validateRoom, 'rooms')}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-600"
                  />
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => removeItem(setRooms, room.id, 'rooms')}
                    className="text-red-600 hover:text-red-800 transition-colors rounded-lg"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

const renderStudentGroups = () => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-semibold text-gray-900">Student Group Management</h2>
      <div className="flex space-x-4">
        <button
          onClick={() => setViewMode('grid')}
          className={`px-3 py-1 rounded-lg ${viewMode === 'grid' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          Grid
        </button>
        <button
          onClick={() => setViewMode('list')}
          className={`px-3 py-1 rounded-lg ${viewMode === 'list' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          List
        </button>
        <button
          onClick={() =>
            addItem(setStudentGroups, { 
              name: 'Group ' + (studentGroups.length + 1),
              count: 30,
              faculty: academicPeriod.faculty?.[0] || '',
              courses: [] 
            }, validateStudentGroup, 'studentGroups')
          }
          className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          <Plus className="w-4 h-4" />
          <span>Add Group</span>
        </button>
        <button
            onClick={() => handleNextTab('students')}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <ArrowRight className="w-4 h-4" />
            <span>Next</span>
          </button>
      
      </div>
    </div>

    {/* Form-level error */}
    {validationErrors.studentGroups?.form && (
      <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2">
        <AlertCircle className="w-5 h-5 text-red-500" />
        <span className="text-sm text-red-600">{validationErrors.studentGroups.form}</span>
      </div>
    )}

    <div className="max-h-[500px] overflow-y-auto">
      {viewMode === 'grid' ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {studentGroups.map(group => {
            const groupErrors = validationErrors.studentGroups?.[group.id];
            return (
              <div key={group.id} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                {/* Group-level errors */}
                {groupErrors && Object.values(groupErrors).filter(Boolean).length > 0 && (
                  <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                    {Object.values(groupErrors).filter(Boolean).map((error, i) => (
                      <div key={i} className="flex items-start space-x-2 text-sm text-red-600">
                        <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
                        <span>{error}</span>
                      </div>
                    ))}
                  </div>
                )}

                <div className="flex justify-between items-start mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-orange-100 rounded-lg">
                      <Users className="w-5 h-5 text-orange-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{group.name || 'New Group'}</h3>
                      <p className="text-sm text-gray-600">{group.faculty}</p>
                    </div>
                  </div>
                  <button
                    onClick={() => removeItem(setStudentGroups, group.id)}
                    className="text-red-600 hover:text-red-800 transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Group Name</label>
                    <input
                      type="text"
                      value={group.name}
                      onChange={(e) => updateItem(setStudentGroups, group.id, { name: e.target.value }, validateStudentGroup, 'studentGroups')}
                      className={`w-full border ${groupErrors?.name ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    />
                    {groupErrors?.name && (
                      <p className="mt-1 text-sm text-red-600">{groupErrors.name}</p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Faculty</label>
                    <select
                      value={group.faculty}
                      onChange={(e) => updateItem(setStudentGroups, group.id, { faculty: e.target.value }, validateStudentGroup, 'studentGroups')}
                      className={`w-full border ${groupErrors?.faculty ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    >
                      <option value="">Select Faculty</option>
                      {[...(academicPeriod.faculty || []), ...(academicPeriod.customFaculties || [])].map((faculty) => (
                        <option key={faculty} value={faculty}>{faculty}</option>
                      ))}
                    </select>
                    {groupErrors?.faculty && (
                      <p className="mt-1 text-sm text-red-600">{groupErrors.faculty}</p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Student Count</label>
                    <input
                      type="number"
                      value={group.count}
                      onChange={(e) => updateItem(setStudentGroups, group.id, { count: parseInt(e.target.value) || 0 }, validateStudentGroup, 'studentGroups')}
                      className={`w-full border ${groupErrors?.count ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    />
                    {groupErrors?.count && (
                      <p className="mt-1 text-sm text-red-600">{groupErrors.count}</p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Courses</label>
                    <Select
                      isMulti
                      options={courseOptions.filter(option => 
                        courses.some(c => c.code === option.value && c.faculty === group.faculty)
                      )}
                      value={courseOptions.filter(option => group.courses.includes(option.value))}
                      onChange={(selected) => {
                        const selectedCourses = selected ? selected.map(option => option.value) : [];
                        updateItem(setStudentGroups, group.id, { courses: selectedCourses }, validateStudentGroup, 'studentGroups');
                      }}
                      classNamePrefix="react-select"
                      className="w-full"
                      isDisabled={!group.faculty}
                      placeholder={group.faculty ? "Select courses..." : "Select faculty first"}
                    />
                    {groupErrors?.courses && (
                      <p className="mt-1 text-sm text-red-600">{groupErrors.courses}</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200">
          <div className="grid grid-cols-5 gap-4 p-4 bg-gray-50 border-b">
            <div className="font-semibold text-gray-700">Group Name</div>
            <div className="font-semibold text-gray-700">Faculty</div>
            <div className="font-semibold text-gray-700">Student Count</div>
            <div className="font-semibold text-gray-700">Courses</div>
            <div className="font-semibold text-gray-700">Actions</div>
          </div>
          {studentGroups.map(group => {
            const groupErrors = validationErrors.studentGroups?.[group.id];
            return (
              <div key={group.id} className="grid grid-cols-5 gap-4 p-4 border-b border-gray-100 items-center">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Group Name</label>
                  <input
                    type="text"
                    value={group.name}
                    onChange={(e) => updateItem(setStudentGroups, group.id, { name: e.target.value }, validateStudentGroup, 'studentGroups')}
                    className={`w-full border ${groupErrors?.name ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {groupErrors?.name && (
                    <p className="mt-1 text-sm text-red-600">{groupErrors.name}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Faculty</label>
                  <select
                    value={group.faculty}
                    onChange={(e) => updateItem(setStudentGroups, group.id, { faculty: e.target.value }, validateStudentGroup, 'studentGroups')}
                    className={`w-full border ${groupErrors?.faculty ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  >
                    <option value="">Select Faculty</option>
                    {[...(academicPeriod.faculty || []), ...(academicPeriod.customFaculties || [])].map((faculty) => (
                      <option key={faculty} value={faculty}>{faculty}</option>
                    ))}
                  </select>
                  {groupErrors?.faculty && (
                    <p className="mt-1 text-sm text-red-600">{groupErrors.faculty}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Student Count</label>
                  <input
                    type="number"
                    value={group.count}
                    onChange={(e) => updateItem(setStudentGroups, group.id, { count: parseInt(e.target.value) || 0 }, validateStudentGroup, 'studentGroups')}
                    className={`w-full border ${groupErrors?.count ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {groupErrors?.count && (
                    <p className="mt-1 text-sm text-red-600">{groupErrors.count}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Courses</label>
                  <Select
                      isMulti
                      options={courseOptions.filter(option => 
                        courses.some(c => c.code === option.value && c.faculty === group.faculty)
                      )}
                      value={courseOptions.filter(option => group.courses.includes(option.value))}
                      onChange={(selected) => {
                        const selectedCourses = selected ? selected.map(option => option.value) : [];
                        updateItem(setStudentGroups, group.id, { courses: selectedCourses }, validateStudentGroup, 'studentGroups');
                      }}
                      classNamePrefix="react-select"
                      className="w-full"
                      isDisabled={!group.faculty}
                      placeholder={group.faculty ? "Select courses..." : "Select faculty first"}
                    />
                    {groupErrors?.courses && (
                      <p className="mt-1 text-sm text-red-600">{groupErrors.courses}</p>
                    )}
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => removeItem(setStudentGroups, group.id)}
                    className="text-red-600 hover:text-red-800 transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  </div>
);

const renderCourses = () => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-semibold text-gray-900">Course Management</h2>
      <div className="flex space-x-4">
        <button
          onClick={() => setViewMode('grid')}
          className={`px-3 py-1 rounded-lg ${viewMode === 'grid' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          Grid
        </button>
        <button
          onClick={() => setViewMode('list')}
          className={`px-3 py-1 rounded-lg ${viewMode === 'list' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          List
        </button>
        <button
          onClick={() =>            
            addItem(setCourses, {
              code: 'CS' + (courses.length + 100),
              name: 'New Course',
              faculty: academicPeriod.faculty?.[0] || '', 
              duration: 45,
              sessionsPerWeek: 3,
              sessionDuration: 1,
              roomType: 'General Classroom',
              type: 'mandatory',
            }, validateCourse, 'courses')
          }
          className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          <Plus className="w-4 h-4" />
          <span>Add Course</span>
        </button>
        <button
            onClick={() => handleNextTab('courses')}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <ArrowRight className="w-4 h-4" />
            <span>Next</span>        
        </button>
      </div>
    </div>

    {/* Form-level error */}
    {validationErrors.courses?.form && (
      <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2">
        <AlertCircle className="w-5 h-5 text-red-500" />
        <span className="text-sm text-red-600">{validationErrors.courses.form}</span>
      </div>
    )}

    <div className="max-h-[500px] overflow-y-auto">
      {viewMode === 'grid' ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map(course => {
            const courseErrors = validationErrors.courses?.[course.id];
            return (
              <div key={course.id} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                {/* Course-level errors */}
                {courseErrors && Object.values(courseErrors).filter(Boolean).length > 0 && (
                  <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                    {Object.values(courseErrors).filter(Boolean).map((error, i) => (
                      <div key={i} className="flex items-start space-x-2 text-sm text-red-600">
                        <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
                        <span>{error}</span>
                      </div>
                    ))}
                  </div>
                )}

                <div className="flex justify-between items-start mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-blue-100 rounded-lg">
                      <BookOpen className="w-5 h-5 text-blue-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{course.name || 'New Course'}</h3>
                      <p className="text-sm text-gray-600">{course.code}</p>
                    </div>
                  </div>
                  <button
                    onClick={() => removeItem(setCourses, course.id)}
                    className="text-red-600 hover:text-red-800 transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Course Code</label>
                    <input
                      type="text"
                      value={course.code}
                      onChange={(e) => updateItem(setCourses, course.id, { code: e.target.value }, validateCourse, 'courses')}
                      className={`w-full border ${courseErrors?.code ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    />
                    {courseErrors?.code && (
                      <p className="mt-1 text-sm text-red-600">{courseErrors.code}</p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Course Name</label>
                    <input
                      type="text"
                      value={course.name}
                      onChange={(e) => updateItem(setCourses, course.id, { name: e.target.value }, validateCourse, 'courses')}
                      className={`w-full border ${courseErrors?.name ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    />
                    {courseErrors?.name && (
                      <p className="mt-1 text-sm text-red-600">{courseErrors.name}</p>
                    )}
                  </div>                
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Faculty</label>
                    <select
                      value={course.faculty}
                      onChange={(e) => updateItem(setCourses, course.id, { faculty: e.target.value }, validateCourse, 'courses')}
                      className={`w-full border ${courseErrors?.faculty ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                    >
                      <option value="">Select Faculty</option>
                      {[...(academicPeriod.faculty || []), ...(academicPeriod.customFaculties || [])].map((faculty) => (
                        <option key={faculty} value={faculty}>{faculty}</option>
                      ))}
                    </select>
                    {courseErrors?.faculty && (
                      <p className="mt-1 text-sm text-red-600">{courseErrors.faculty}</p>
                    )}
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Duration (minutes)</label>
                      <input
                        type="number"
                        value={course.duration}
                        onChange={(e) => updateItem(setCourses, course.id, { duration: parseInt(e.target.value) || 0 }, validateCourse, 'courses')}
                        className={`w-full border ${courseErrors?.duration ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                      />
                      {courseErrors?.duration && (
                        <p className="mt-1 text-sm text-red-600">{courseErrors.duration}</p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Sessions/Week</label>
                      <input
                        type="number"
                        value={course.sessionsPerWeek}
                        onChange={(e) => updateItem(setCourses, course.id, { sessionsPerWeek: parseInt(e.target.value) || 0 }, validateCourse, 'courses')}
                        className={`w-full border ${courseErrors?.sessionsPerWeek ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                      />
                      {courseErrors?.sessionsPerWeek && (
                        <p className="mt-1 text-sm text-red-600">{courseErrors.sessionsPerWeek}</p>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Session Duration (hours)</label>
                      <input
                        type="number"
                        value={course.sessionDuration}
                        onChange={(e) => updateItem(setCourses, course.id, { sessionDuration: parseInt(e.target.value) || 0 }, validateCourse, 'courses')}
                        className={`w-full border ${courseErrors?.sessionDuration ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                      />
                      {courseErrors?.sessionDuration && (
                        <p className="mt-1 text-sm text-red-600">{courseErrors.sessionDuration}</p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Room Type</label>
                      <select
                        value={course.roomType}
                        onChange={(e) => updateItem(setCourses, course.id, { roomType: e.target.value }, validateCourse, 'courses')}
                        className={`w-full border ${courseErrors?.roomType ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                      >
                        <option value="General Classroom">General Classroom</option>
                        <option value="Lecture Hall">Lecture Hall</option>
                        <option value="Computer Lab">Computer Lab</option>
                        <option value="Chemistry Lab">Chemistry Lab</option>
                      </select>
                      {courseErrors?.roomType && (
                        <p className="mt-1 text-sm text-red-600">{courseErrors.roomType}</p>
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Type</label>
                    <select
                      value={course.type}
                      onChange={(e) => updateItem(setCourses, course.id, { type: e.target.value }, validateCourse, 'courses')}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                      <option value="mandatory">Mandatory</option>
                      <option value="elective">Elective</option>
                    </select>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200">
          <div className="grid grid-cols-8 gap-4 p-4 bg-gray-50 border-b">
            <div className="font-semibold text-gray-700">Code</div>
            <div className="font-semibold text-gray-700">Name</div>
            <div className="font-semibold text-gray-700">Department</div>
            <div className="font-semibold text-gray-700">Duration</div>
            <div className="font-semibold text-gray-700">Sessions/Week</div>
            <div className="font-semibold text-gray-700">Session Duration</div>
            <div className="font-semibold text-gray-700">Room Type</div>
            <div className="font-semibold text-gray-700">Actions</div>
          </div>
          {courses.map(course => {
            const courseErrors = validationErrors.courses?.[course.id];
            return (
              <div key={course.id} className="grid grid-cols-8 gap-4 p-4 border-b border-gray-100 items-center">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Code</label>
                  <input
                    type="text"
                    value={course.code}
                    onChange={(e) => updateItem(setCourses, course.id, { code: e.target.value }, validateCourse, 'courses')}
                    className={`w-full border ${courseErrors?.code ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {courseErrors?.code && (
                    <p className="mt-1 text-sm text-red-600">{courseErrors.code}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Name</label>
                  <input
                    type="text"
                    value={course.name}
                    onChange={(e) => updateItem(setCourses, course.id, { name: e.target.value }, validateCourse, 'courses')}
                    className={`w-full border ${courseErrors?.name ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {courseErrors?.name && (
                    <p className="mt-1 text-sm text-red-600">{courseErrors.name}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Department</label>
                  <input
                    type="text"
                    value={course.department}
                    onChange={(e) => updateItem(setCourses, course.id, { department: e.target.value }, validateCourse, 'courses')}
                    className={`w-full border ${courseErrors?.department ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {courseErrors?.department && (
                    <p className="mt-1 text-sm text-red-600">{courseErrors.department}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Duration</label>
                  <input
                    type="number"
                    value={course.duration}
                    onChange={(e) => updateItem(setCourses, course.id, { duration: parseInt(e.target.value) || 0 }, validateCourse, 'courses')}
                    className={`w-full border ${courseErrors?.duration ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {courseErrors?.duration && (
                    <p className="mt-1 text-sm text-red-600">{courseErrors.duration}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Sessions/Week</label>
                  <input
                    type="number"
                    value={course.sessionsPerWeek}
                    onChange={(e) => updateItem(setCourses, course.id, { sessionsPerWeek: parseInt(e.target.value) || 0 }, validateCourse, 'courses')}
                    className={`w-full border ${courseErrors?.sessionsPerWeek ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {courseErrors?.sessionsPerWeek && (
                    <p className="mt-1 text-sm text-red-600">{courseErrors.sessionsPerWeek}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Session Duration</label>
                  <input
                    type="number"
                    value={course.sessionDuration}
                    onChange={(e) => updateItem(setCourses, course.id, { sessionDuration: parseInt(e.target.value) || 0 }, validateCourse, 'courses')}
                    className={`w-full border ${courseErrors?.sessionDuration ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {courseErrors?.sessionDuration && (
                    <p className="mt-1 text-sm text-red-600">{courseErrors.sessionDuration}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Room Type</label>
                  <select
                    value={course.roomType}
                    onChange={(e) => updateItem(setCourses, course.id, { roomType: e.target.value }, validateCourse, 'courses')}
                    className={`w-full border ${courseErrors?.roomType ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  >
                    <option value="General Classroom">General Classroom</option>
                    <option value="Lecture Hall">Lecture Hall</option>
                    <option value="Computer Lab">Computer Lab</option>
                    <option value="Chemistry Lab">Chemistry Lab</option>
                  </select>
                  {courseErrors?.roomType && (
                    <p className="mt-1 text-sm text-red-600">{courseErrors.roomType}</p>
                  )}
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => removeItem(setCourses, course.id)}
                    className="text-red-600 hover:text-red-800 transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  </div>
);

const renderLecturers = () => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-semibold text-gray-900">Lecturer Management</h2>
      <div className="flex space-x-4">
        <button
          onClick={() => setViewMode('grid')}
          className={`px-3 py-1 rounded-lg ${viewMode === 'grid' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          Grid
        </button>
        <button
          onClick={() => setViewMode('list')}
          className={`px-3 py-1 rounded-lg ${viewMode === 'list' ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          List
        </button>
        <button
            onClick={() => {
              const newLecturer = {
                id: lecturers.length > 0 ? Math.max(...lecturers.map(l => l.id)) + 1 : 1,
                name: 'Lecturer ' + (lecturers.length + 1),
                faculty: academicPeriod.faculty?.[0] || '',
                maxLoad: 20,
                courses: [],
                availability: { 
                  monday: true, 
                  tuesday: true, 
                  wednesday: true, 
                  thursday: true, 
                  friday: true 
                },
              };
              
              setLecturers(prev => [...prev, newLecturer]);
            }}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
            <span>Add Lecturer</span>
          </button>
        <button
            onClick={() => handleNextTab('lecturers')}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <ArrowRight className="w-4 h-4" />
            <span>Next</span>        
        </button>
       
      </div>
    </div>

    {/* Form-level error */}
    {validationErrors.lecturers?.form && (
      <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2">
        <AlertCircle className="w-5 h-5 text-red-500" />
        <span className="text-sm text-red-600">{validationErrors.lecturers.form}</span>
      </div>
    )}

    <div className="max-h-[500px] overflow-y-auto">
      {viewMode === 'grid' ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {lecturers.map(lecturer => {
            const lecturerErrors = validationErrors.lecturers?.[lecturer.id];
            return (
              <div key={lecturer.id} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                {/* Lecturer-level errors */}
                {lecturerErrors && Object.values(lecturerErrors).filter(Boolean).length > 0 && (
                  <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                    {Object.values(lecturerErrors).filter(Boolean).map((error, i) => (
                      <div key={i} className="flex items-start space-x-2 text-sm text-red-600">
                        <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
                        <span>{error}</span>
                      </div>
                    ))}
                  </div>
                )}

                <div className="flex justify-between items-start mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-green-100 rounded-lg">
                      <User className="w-5 h-5 text-green-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{lecturer.name || 'New Lecturer'}</h3>
                      <p className="text-sm text-gray-600">{lecturer.faculty}</p>
                    </div>
                  </div>
                  <button
                    onClick={() => removeItem(setLecturers, lecturer.id)}
                    className="text-red-600 hover:text-red-800 transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Name</label>
                    <input
                      type="text"
                      value={lecturer.name}
                      onChange={(e) => updateItem(setLecturers, lecturer.id, { name: e.target.value }, validateLecturer, 'lecturers')}
                      className={`w-full border ${lecturerErrors?.name ? 'border-red-500' : 'border-gray-600'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-700`}
                    />
                    {lecturerErrors?.name && (
                      <p className="mt-1 text-sm text-red-600">{lecturerErrors?.name}</p>
                    )}
                  </div>
                  {/* In the list view, replace the faculty input with: */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Faculty</label>
                      <select
                        value={lecturer.faculty}
                        onChange={(e) => updateItem(setLecturers, lecturer.id, { faculty: e.target.value }, validateLecturer, 'lecturers')}
                        className={`w-full border ${lecturerErrors?.faculty ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                      >
                        <option value="">Select Faculty</option>
                        {[...(academicPeriod.faculty || []), ...(academicPeriod.customFaculties || [])].map((faculty) => (
                          <option key={faculty} value={faculty}>{faculty}</option>
                        ))}
                      </select>
                      {lecturerErrors?.faculty && (
                        <p className="mt-1 text-sm text-red-600">{lecturerErrors.faculty}</p>
                      )}
                    </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Max Load (hours)</label>
                    <input
                      type="number"
                      value={lecturer.maxLoad}
                      onChange={(e) => updateItem(setLecturers, lecturer.id, { maxLoad: parseInt(e.target.value) || 0 }, validateLecturer, 'lecturers')}
                      className={`w-full border ${lecturerErrors?.maxLoad ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-600`}
                    />
                    {lecturerErrors?.maxLoad && (
                      <p className="mt-1 text-sm text-red-600">{lecturerErrors?.maxLoad}</p>
                    )}
                  </div>
                 <div>
                    <label className="block text-sm font-medium text-gray-700">Courses</label>
                    <Select
                      isMulti
                      options={courseOptions}
                      value={courseOptions.filter(option => lecturer.courses.includes(option.value))}
                      onChange={(selected) => {
                        const selectedCourses = selected ? selected.map(option => option.value) : [];
                        updateItem(setLecturers, lecturer.id, { courses: selectedCourses }, validateLecturer, 'lecturers');
                      }}
                      classNamePrefix="react-select"
                      className="w-full"
                      isDisabled={!lecturer.faculty} // Disable if no faculty selected
                      placeholder={lecturer.faculty ? "Select courses..." : "Select faculty first"}
                    />
                    {lecturerErrors?.courses && (
                      <p className="mt-1 text-sm text-red-600">{lecturerErrors.courses}</p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Availability</label>
                    <div className="grid grid-cols-3 gap-2">
                      {['monday', 'tuesday', 'wednesday', 'thursday', 'friday'].map(day => (
                        <label key={day} className="flex items-center space-x-2">
                          <input
                            type="checkbox"
                            checked={lecturer.availability[day]}
                            onChange={(e) =>
                              updateItem(setLecturers, lecturer.id, {
                                availability: { ...lecturer.availability, [day]: e.target.checked },
                              }, validateLecturer, 'lecturers')
                            }
                            className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                          />
                          <span className="text-sm text-gray-700">{day.charAt(0).toUpperCase() + day.slice(1)}</span>
                        </label>
                      ))}
                    </div>
                    {lecturerErrors?.availability && (
                      <p className="mt-1 text-sm text-red-600">{lecturerErrors.availability}</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200">
          <div className="grid grid-cols-6 gap-4 p-4 bg-gray-50 border-b">
            <div className="font-semibold text-gray-700">Name</div>
            <div className="font-semibold text-gray-700">faculty</div>
            <div className="font-semibold text-gray-700">Max Load</div>
            <div className="font-semibold text-gray-700">Courses</div>
            <div className="font-semibold text-gray-700">Availability</div>
            <div className="font-semibold text-gray-700">Actions</div>
          </div>
          {lecturers.map(lecturer => {
            const lecturerErrors = validationErrors.lecturers?.[lecturer.id];
            return (
              <div key={lecturer.id} className="grid grid-cols-6 gap-4 p-4 border-b border-gray-100 items-center">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Name</label>
                  <input
                    type="text"
                    value={lecturer.name}
                    onChange={(e) => updateItem(setLecturers, lecturer.id, { name: e.target.value }, validateLecturer, 'lecturers')}
                    className={`w-full border ${lecturerErrors?.name ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {lecturerErrors?.name && (
                    <p className="mt-1 text-sm text-red-600">{lecturerErrors.name}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">faculty</label>
                  <input
                    type="text"
                    value={lecturer.faculty}
                    onChange={(e) => updateItem(setLecturers, lecturer.id, { faculty: e.target.value }, validateLecturer, 'lecturers')}
                    className={`w-full border ${lecturerErrors?.faculty ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {lecturerErrors?.faculty && (
                    <p className="mt-1 text-sm text-red-600">{lecturerErrors.faculty}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Max Load</label>
                  <input
                    type="number"
                    value={lecturer.maxLoad}
                    onChange={(e) => updateItem(setLecturers, lecturer.id, { maxLoad: parseInt(e.target.value) || 0 }, validateLecturer, 'lecturers')}
                    className={`w-full border ${lecturerErrors?.maxLoad ? 'border-red-500' : 'border-gray-300'} rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                  />
                  {lecturerErrors?.maxLoad && (
                    <p className="mt-1 text-sm text-red-600">{lecturerErrors.maxLoad}</p>
                  )}
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700">Courses</label>
                  <Select
                      isMulti
                      options={courseOptions}
                      value={courseOptions.filter(option => lecturer.courses.includes(option.value))}
                      onChange={(selected) => {
                        const selectedCourses = selected ? selected.map(option => option.value) : [];
                        updateItem(setLecturers, lecturer.id, { courses: selectedCourses }, validateLecturer, 'lecturers');
                      }}
                      classNamePrefix="react-select"
                      className="w-full"
                      isDisabled={!lecturer.faculty} // Disable if no faculty selected
                      placeholder={lecturer.faculty ? "Select courses..." : "Select faculty first"}
                    />
                    {lecturerErrors?.courses && (
                      <p className="mt-1 text-sm text-red-600">{lecturerErrors.courses}</p>
                    )}                  
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Availability</label>
                  <div className="flex space-x-2">
                    {['M', 'T', 'W', 'Th', 'F'].map((day, i) => (
                      <span key={day} className={`text-xs ${lecturer.availability[['monday', 'tuesday', 'wednesday', 'thursday', 'friday'][i]] ? 'text-green-600' : 'text-gray-400'}`}>
                        {day}
                      </span>
                    ))}
                  </div>
                  {lecturerErrors?.availability && (
                    <p className="mt-1 text-sm text-red-600">{lecturerErrors.availability}</p>
                  )}
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => removeItem(setLecturers, lecturer.id)}
                    className="text-red-600 hover:text-red-800 transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  </div>
);


const renderConstraints = () => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-semibold text-gray-900">Scheduling Constraints</h2>
      <button
            onClick={() => handleNextTab('constraints')}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <ArrowRight className="w-4 h-4" />
            <span>Next</span>        
        </button>
      
    </div>
    {validationErrors.constraints?.form && (
      <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2">
        <AlertCircle className="w-5 h-5 text-red-500" />
        <span className="text-sm text-red-600">{validationErrors.constraints.form}</span>
      </div>
    )}
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700">Max Consecutive Hours</label>
          <input
            type="number"
            value={constraints.maxConsecutiveHours}
            onChange={(e) => {
              const newValue = parseInt(e.target.value) || 0;
              setConstraints(prev => {
                const updatedConstraints = { ...prev, maxConsecutiveHours: newValue };
                const errors = validateConstraints(updatedConstraints);
                setValidationErrors(prevErrors => ({
                  ...prevErrors,
                  constraints: errors || {}
                }));
                return updatedConstraints;
              });
            }}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Min Break Between Sessions (minutes)</label>
          <input
            type="number"
            value={constraints.minBreakBetweenSessions}
            onChange={(e) => {
              const newValue = parseInt(e.target.value) || 0;
              setConstraints(prev => {
                const updatedConstraints = { ...prev, minBreakBetweenSessions: newValue };
                const errors = validateConstraints(updatedConstraints);
                setValidationErrors(prevErrors => ({
                  ...prevErrors,
                  constraints: errors || {}
                }));
                return updatedConstraints;
              });
            }}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Max Lecturer Daily Hours</label>
          <input
            type="number"
            value={constraints.maxLecturerDailyHours}
            onChange={(e) => {
              const newValue = parseInt(e.target.value) || 0;
              setConstraints(prev => {
                const updatedConstraints = { ...prev, maxLecturerDailyHours: newValue };
                const errors = validateConstraints(updatedConstraints);
                setValidationErrors(prevErrors => ({
                  ...prevErrors,
                  constraints: errors || {}
                }));
                return updatedConstraints;
              });
            }}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Room Utilization Threshold (0-1)</label>
          <input
            type="number"
            step="0.1"
            value={constraints.roomUtilizationThreshold}
            onChange={(e) => {
              const newValue = parseFloat(e.target.value) || 0;
              setConstraints(prev => {
                const updatedConstraints = { ...prev, roomUtilizationThreshold: newValue };
                const errors = validateConstraints(updatedConstraints);
                setValidationErrors(prevErrors => ({
                  ...prevErrors,
                  constraints: errors || {}
                }));
                return updatedConstraints;
              });
            }}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={constraints.preferMorningSlots}
            onChange={(e) => {
              const newValue = e.target.checked;
              setConstraints(prev => {
                const updatedConstraints = { ...prev, preferMorningSlots: newValue };
                const errors = validateConstraints(updatedConstraints);
                setValidationErrors(prevErrors => ({
                  ...prevErrors,
                  constraints: errors || {}
                }));
                return updatedConstraints;
              });
            }}
            className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <label className="text-sm font-medium text-gray-700">Prefer Morning Slots</label>
        </div>
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={constraints.clusterStudentClasses}
            onChange={(e) => {
              const newValue = e.target.checked;
              setConstraints(prev => {
                const updatedConstraints = { ...prev, clusterStudentClasses: newValue };
                const errors = validateConstraints(updatedConstraints);
                setValidationErrors(prevErrors => ({
                  ...prevErrors,
                  constraints: errors || {}
                }));
                return updatedConstraints;
              });
            }}
            className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <label className="text-sm font-medium text-gray-700">Cluster Student Classes</label>
        </div>
      </div>
    </div>
  </div>
);

// Render Generate Tab
// Render Generate Tab
const renderGenerate = () => (
  <div className="space-y-6">
    <h2 className="text-xl font-semibold text-gray-900">Generate Timetable</h2>
    <div className="flex space-x-4">
      <button
        onClick={saveAllData}
        className="flex items-center space-x-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors"
      >
        <Save className="w-4 h-4" />
        <span>Save All</span>
      </button>
      <button
        onClick={generateTimetable}
        disabled={generationStatus === 'running'}
        className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
          generationStatus === 'running'
            ? 'bg-gray-400 text-gray-100 cursor-not-allowed'
            : 'bg-blue-600 text-white hover:bg-blue-700'
        }`}
      >
        <Play className="w-4 h-4" />
        <span>Generate</span>
      </button>
    </div>

    {/* General Error Message */}
    {errors['generate'] && (
      <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2">
        <AlertCircle className="w-5 h-5 text-red-500" />
        <span className="text-sm text-red-600">{errors['generate']}</span>
      </div>
    )}

    {/* Generation Status */}
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">Generation Status</h3>
      <div className="flex items-center">
        <span className={`text-sm ${
          generationStatus === 'running' ? 'text-blue-600' :
          generationStatus === 'success' ? 'text-green-600' :
          generationStatus === 'error' ? 'text-red-600' : 'text-gray-600'
        }`}>
          {generationStatus === 'running' ? 'Generating...' :
           generationStatus === 'success' ? 'Completed Successfully' :
           generationStatus === 'error' ? 'Failed with Conflicts' : 'Idle'}
        </span>
        {generationStatus === 'success' && timetable.length > 0 && conflicts.length === 0 && (
          <button
            onClick={() => {/* Implement download logic */}}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors ml-4"
          >
            <Download className="w-4 h-4" />
            <span>Download Timetable</span>
          </button>
        )}
        {(timetable.length > 0 || conflicts.length > 0) && (
          <button
            onClick={() => {
              axios.post('/api/timetable-analytics', {
                timetable,
                rooms,
                lecturers,
                student_groups: studentGroups,
                time_slots: timeSlots,
                working_days: academicPeriod.workingDays
              }).then(res => {
                setAnalytics(res.data);
                setActiveTab('analysis');
              }).catch(err => console.error('Analytics fetch failed:', err));
            }}
            className="flex items-center space-x-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors ml-4"
          >
            <BarChart2 className="w-4 h-4" />
            <span>View Analysis</span>
          </button>
        )}
      </div>
    </div>

    {/* Conflicts Grid */}
    {conflicts.length > 0 && (
      <div className="mt-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Scheduling Conflicts</h3>
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="grid grid-cols-4 gap-4 p-4 bg-gray-50 border-b border-gray-200">
            <div className="font-semibold text-gray-700">Conflict</div>
            <div className="font-semibold text-gray-700">Details</div>
            <div className="font-semibold text-gray-700">Solution</div>
            <div className="font-semibold text-gray-700">Action</div>
          </div>
          {conflicts.map((conflict, index) => {
            const tabId = getConflictTab(conflict);
            const tabName = tabs.find(tab => tab.id === tabId)?.name || 'Overview';
            return (
              <div key={index} className="grid grid-cols-4 gap-4 p-4 border-b border-gray-100 items-center">
                <div className="text-sm text-red-600 flex items-center space-x-2">
                  <AlertCircle className="w-4 h-4" />
                  <span>Conflict #{index + 1}</span>
                </div>
                <div className="text-sm text-gray-700">{conflict.message}</div>
                <div className="text-sm text-gray-700">{conflict.solution}</div>
                <div>
                  <button
                    onClick={() => setActiveTab(tabId)}
                    className="flex items-center space-x-1 text-blue-600 hover:text-blue-800 text-sm"
                  >
                    <ArrowRight className="w-4 h-4" />
                    <span>Edit {tabName}</span>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    )}

    {/* Summary Metrics */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="text-sm text-gray-600">Courses Scheduled</div>
        <div className="text-2xl font-bold text-gray-900">
          {timetable.length > 0 ? new Set(timetable.map(s => s.course)).size : 0}
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="text-sm text-gray-600">Rooms Utilized</div>
        <div className="text-2xl font-bold text-gray-900">
          {timetable.length > 0 ? new Set(timetable.map(s => s.room)).size : 0}
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="text-sm text-gray-600">Lecturers Assigned</div>
        <div className="text-2xl font-bold text-gray-900">
          {timetable.length > 0 ? new Set(timetable.map(s => s.lecturer)).size : 0}
        </div>
      </div>
    </div>
  </div>
);

// Render Analysis Tab
const renderAnalysis = () => {
  const workingDays = academicPeriod.workingDays || ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
  const timeSlotsFormatted = timeSlots
    .filter(slot => slot.type === 'teaching')
    .map(slot => ({ start: slot.start, end: slot.end }))
    .sort((a, b) => a.start.localeCompare(b.start));

  // Prepare heatmap data
  const heatmapData = Object.entries(analytics.full_heatmap || {}).map(([key, count]) => {
    const [day, time] = key.split('_');
    return { date: `2025/01/${workingDays.indexOf(day.charAt(0).toUpperCase() + day.slice(1)) + 1}`, count };
  });

  const roomHeatmapData = Object.entries(analytics.room_heatmap || {}).reduce((acc, [room, slots]) => {
    acc[room] = Object.entries(slots).map(([key, count]) => {
      const [day, time] = key.split('_');
      return { date: `2025/01/${workingDays.indexOf(day.charAt(0).toUpperCase() + day.slice(1)) + 1}`, count };
    });
    return acc;
  }, {});

  const lecturerHeatmapData = Object.entries(analytics.lecturer_heatmap || {}).reduce((acc, [lecturer, slots]) => {
    acc[lecturer] = Object.entries(slots).map(([key, count]) => {
      const [day, time] = key.split('_');
      return { date: `2025/01/${workingDays.indexOf(day.charAt(0).toUpperCase() + day.slice(1)) + 1}`, count };
    });
    return acc;
  }, {});

  const groupHeatmapData = Object.entries(analytics.group_heatmap || {}).reduce((acc, [group, slots]) => {
    acc[group] = Object.entries(slots).map(([key, count]) => {
      const [day, time] = key.split('_');
      return { date: `2025/01/${workingDays.indexOf(day.charAt(0).toUpperCase() + day.slice(1)) + 1}`, count };
    });
    return acc;
  }, {});

  // Filter timetable based on search query
  const filteredTimetable = timetable.filter(session =>
    session.course.toLowerCase().includes(searchQuery.toLowerCase()) ||
    session.lecturer.toLowerCase().includes(searchQuery.toLowerCase()) ||
    session.studentGroup.toLowerCase().includes(searchQuery.toLowerCase()) ||
    session.room.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">Timetable Analysis</h2>

      {/* Search Bar */}
      <div className="flex items-center space-x-2 bg-white p-4 rounded-lg shadow-sm border border-gray-200">
        <Search className="w-5 h-5 text-gray-500" />
        <input
          type="text"
          placeholder="Search by course, lecturer, room, or group..."
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          className="w-full p-2 border-none focus:outline-none"
        />
      </div>

      {/* Issues */}
      {analytics.issues && analytics.issues.length > 0 && (
        <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <h3 className="text-lg font-semibold text-yellow-800 mb-2">Detected Issues</h3>
          <ul className="list-disc pl-5 space-y-1">
            {analytics.issues.map((issue, index) => (
              <li key={index} className="text-sm text-yellow-700">{issue}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Full Timetable Heatmap */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Full Timetable Heatmap</h3>
        <HeatMap
          value={heatmapData}
          weekLabels={workingDays}
          startDate={new Date('2025/01/01')}
          endDate={new Date('2025/01/07')}
          panelColors={{
            0: '#EBEDF0',
            1: '#C6E48B',
            2: '#7BC96F',
            3: '#239A3B',
            4: '#196127'
          }}
        />
      </div>

      {/* Room Heatmaps */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Room Utilization Heatmaps</h3>
        {Object.entries(roomHeatmapData).map(([room, data]) => (
          <div key={room} className="mb-6">
            <h4 className="text-md font-medium text-gray-800">{room}</h4>
            <HeatMap
              value={data}
              weekLabels={workingDays}
              startDate={new Date('2025/01/01')}
              endDate={new Date('2025/01/07')}
              panelColors={{
                0: '#EBEDF0',
                1: '#C6E48B',
                2: '#7BC96F',
                3: '#239A3B',
                4: '#196127'
              }}
            />
          </div>
        ))}
      </div>

      {/* Lecturer Heatmaps */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Lecturer Load Heatmaps</h3>
        {Object.entries(lecturerHeatmapData).map(([lecturer, data]) => (
          <div key={lecturer} className="mb-6">
            <h4 className="text-md font-medium text-gray-800">{lecturer}</h4>
            <HeatMap
              value={data}
              weekLabels={workingDays}
              startDate={new Date('2025/01/01')}
              endDate={new Date('2025/01/07')}
              panelColors={{
                0: '#EBEDF0',
                1: '#C6E48B',
                2: '#7BC96F',
                3: '#239A3B',
                4: '#196127'
              }}
            />
          </div>
        ))}
      </div>

      {/* Student Group Heatmaps */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Student Group Schedules</h3>
        {Object.entries(groupHeatmapData).map(([group, data]) => (
          <div key={group} className="mb-6">
            <h4 className="text-md font-medium text-gray-800">{group}</h4>
            <HeatMap
              value={data}
              weekLabels={workingDays}
              startDate={new Date('2025/01/01')}
              endDate={new Date('2025/01/07')}
              panelColors={{
                0: '#EBEDF0',
                1: '#C6E48B',
                2: '#7BC96F',
                3: '#239A3B',
                4: '#196127'
              }}
            />
          </div>
        ))}
      </div>

      {/* Timetable Table */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Detailed Timetable</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Course</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Lecturer</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Student Group</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Room</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Day</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Time</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredTimetable.map((session, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{session.course}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{session.lecturer}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{session.studentGroup}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{session.room}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{session.day}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{`${session.startTime} - ${session.endTime}`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};


  const renderAuditLog = () => (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">Audit Log</h2>
      <div className="flex space-x-4">
        <button className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
          <Filter className="w-4 h-4" />
          <span>Filter Logs</span>
        </button>
        <button className="flex items-center space-x-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors">
          <Download className="w-4 h-4" />
          <span>Export Logs</span>
        </button>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200">
        <div className="grid grid-cols-4 gap-4 p-4 bg-gray-50 border-b">
          <div className="font-semibold text-gray-700">Timestamp</div>
          <div className="font-semibold text-gray-700">Action</div>
          <div className="font-semibold text-gray-700">Type</div>
          <div className="font-semibold text-gray-700">Details</div>
        </div>
        {auditLogs.map((log, index) => (
          <div key={index} className="grid grid-cols-4 gap-4 p-4 border-b border-gray-100 items-center">
            <div>{new Date(log.timestamp).toLocaleString()}</div>
            <div>{log.action}</div>
            <div>{log.type}</div>
            <div>{log.id ? `ID: ${log.id}` : '-'}</div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Sidebar */}
      <div className={`transition-all duration-300 ${isSidebarOpen ? 'w-64' : 'w-16'} bg-white border-r border-gray-200 flex flex-col`}>
        <div className="flex items-center justify-between px-4 py-4 border-b border-gray-100">
          <span className={`font-bold text-lg text-blue-700 transition-all ${isSidebarOpen ? '' : 'hidden'}`}>Timetable Scheduler</span>
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {isSidebarOpen ? <X className="w-5 h-5 text-gray-600" /> : <Menu className="w-5 h-5 text-gray-600" />}
          </button>
        </div>
        <div className="flex-1 flex flex-col space-y-1 mt-2">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`w-full flex items-center space-x-3 px-4 py-3 text-sm font-medium transition-colors ${
                activeTab === tab.id
                  ? 'bg-blue-50 text-blue-700 border-l-4 border-blue-500'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <tab.icon className="w-5 h-5" />
              <span className={`${isSidebarOpen ? '' : 'hidden'}`}>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
      {/* Main Content */}
      <div className="flex-1 p-8 overflow-y-auto">
        {errors['global'] && (
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-2 mb-4">
            <AlertCircle className="w-5 h-5 text-red-500" />
            <span className="text-sm text-red-600">{errors['global']}</span>
          </div>
        )}
        {activeTab === 'overview' && renderOverview()}
        {activeTab === 'time-slots' && renderTimeSlots()}
        {activeTab === 'rooms' && renderRooms()}
        {activeTab === 'lecturers' && renderLecturers()}
        {activeTab === 'students' && renderStudentGroups()}
        {activeTab === 'courses' && renderCourses()}
        {activeTab === 'constraints' && renderConstraints()}
        {activeTab === 'generate' && renderGenerate()}
        {activeTab === 'analysis' && renderAnalysis()}
        {activeTab === 'audit' && renderAuditLog()}
      </div>
    </div>
  );
};

export default TimetableScheduler;